import { Button } from "@/components/ui/baseUi/button"
import { CloseIcon } from "@images/svgIcons/navigation/closeIcon"
import { cn } from "@modules/lib/utils"

/**
 * This wrapper is used to harmonize the background of the onboarding boxes and Stripe.
 * @component
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - The content to be wrapped.
 * @param {string} [props.className=""] - Additional CSS classes for styling.
 * @param {string} [props.backgroundImage=""] - URL for the background image.
 * @param {function} props.handleClose - Callback function for closing the wrapper.
 * @returns {React.ReactNode} - The wrapped content.
 */
export const BoxOnboardingWrapper = ({
  children,
  className = "",
  backgroundImage = "",
  handleClose,
}: {
  children: React.ReactNode
  handleClose: () => void
  className?: string
  backgroundImage?: string
}): React.ReactNode => {
  return (
    <div
      className={cn(
        "fixed top-0 left-0 h-screen w-full overflow-auto bg-black bg-auto bg-bottom-right bg-no-repeat",
        className,
      )}
      style={{ backgroundImage: `url(${backgroundImage})`, zIndex: 1001 }}
    >
      {/* BUTTON CLOSE  */}
      <Button className="absolute top-0 right-0 z-1 mt-5 mr-5" onClick={handleClose} variant="ghost" size="iconMd">
        <CloseIcon color="var(--neutral-700)" />
      </Button>
      {children}
    </div>
  )
}
